import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { Icon } from '@leagueplatform/genesis-core';
import { COVERED, NOT_COVERED, PARTIAL } from '../constants/coverage.constants';
import { CoverageType } from '../types/coverage-type.type';

interface IconProps {
  size?: string | number;
  title: string;
}

interface CoverageIconProps {
  coverage: CoverageType;
  embedded?: boolean;
}

export const CoveredIcon = ({ size, title, ...rest }: IconProps) => (
  <Icon
    icon="statusSuccessStatus"
    size={size}
    tint="$successIcon"
    label={title}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  />
);

export const NotCoveredIcon = ({ size, title, ...rest }: IconProps) => (
  <Icon
    icon="statusErrorStatus"
    size={size}
    tint="$criticalIcon"
    label={title}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  />
);

export const PartialCoverageIcon = ({ size, title, ...rest }: IconProps) => (
  <Icon
    icon="tinyAlert"
    size={size}
    tint="$warningIcon"
    label={title}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  />
);

export const CoverageIcon = ({ coverage, embedded }: CoverageIconProps) => {
  const { formatMessage } = useIntl();

  switch (coverage) {
    case COVERED:
      return (
        <CoveredIcon
          title={formatMessage({ id: 'COVERED' })}
          size={embedded ? '20px' : '1.5em'}
        />
      );
    case PARTIAL:
      return (
        <PartialCoverageIcon
          title={formatMessage({ id: 'COVERED_WITH_RESTRICTIONS' })}
          size={embedded ? '20px' : '1.5em'}
        />
      );
    case NOT_COVERED:
      return (
        <NotCoveredIcon
          title={formatMessage({ id: 'NOT_COVERED' })}
          size={embedded ? '20px' : '1.5em'}
        />
      );
    default:
      return null;
  }
};

export const RestrictionIcon = (props: any) => (
  <Icon
    icon="tinyAlert"
    size="1.5rem"
    tint="$decorativeBrandTertiaryDefault"
    aria-hidden
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);
